<template>
  <div class="uk-container">
    <div class="uk-alert-warning uk-width-large uk-margin-auto" uk-alert>
      <a class="uk-alert-close" uk-close />
      <div class="uk-text-center">
        <p><b>Note</b>: Operator needs Google Account with the same email address in order to login using SSO and to be able to access Call Center.</p>
        <p class="uk-margin-remove-bottom">You can contact the Administrator for additional information.</p>
      </div>
    </div>

    <user-create :type="2" />
  </div>
</template>

<script>
import UserCreate from '@/components/user/Create.vue'

export default {
  name: 'ViewOperatorCreate',

  components: { UserCreate }
}
</script>
